import ThumbnailList1Src from "../assets/img/card-images/access-health-information_224x224.jpg";
import ThumbnailList1HolSrc from "../assets/img/hol/health-info.jpg";
import ThumbnailList2Src from "../assets/img/card-images/DCA_224x224.jpg";
import ThumbnailList3Src from "../assets/img/card-images/FastTrack_Appointments_224x224.jpg";
import ThumbnailHealthStoreSrc from "../assets/img/card-images/Access-Health-Support_224x224.jpg";
import ThumbnailAskMedExpertSrc from "../assets/img/card-images/Ask-A-Medical-Expert_224x224.jpg";
import { Paths, Urls } from "../constants/UrlConstants";

export const thumbNailHealthInformation = {
  IconSrc: {
    Any: ThumbnailList1Src,
    HOL: ThumbnailList1HolSrc
  },
  Heading: "Health information",
  Description:
    "Find information online and local services with HealthUnlocked, helping you to manage and understand your health.",
  LinkText: "Discover",
  LinkTo: Paths.HealthInformation
};

export const thumbNailGPAppointments = {
  IconSrc: {
    Any: ThumbnailList2Src
  },
  Heading: "GP appointments 24/7",
  Description:
    "Speak to a doctor when you want to, wherever you are, through your smartphone or laptop using our AXA Doctor at Hand service.",
  LinkText: "Discover",
  LinkTo: Paths.GPAppointments247
};

export const thumbNailFastTrackAppointments = {
  IconSrc: ThumbnailList3Src,
  Heading: "Specialist Appointment Booking Service",
  Description:
    "When you need to see a specialist quickly, our Specialist Appointment Booking Service team will make it happen.",
  LinkText: "Discover",
  LinkTo: Paths.FastTrack
};

export const thumbNailFindTreatment = {
  IconSrc: ThumbnailList3Src,
  Heading: "Find treatment",
  Description:
    "MyGlobe can help you find the right medical provider, wherever you need them, with access to our global network.",
  LinkText: "Discover",
  ExternalLinkTo: Urls.FindTreatmentInternational
};

export const thumbNailAccessHealthStore = {
  IconSrc: ThumbnailHealthStoreSrc,
  Heading: "View your member offers", 
  Description:
    "Keep fit for less with our special gym offer or explore your health and lifestyle with a discounted health assessment.",
  LinkText: "Discover",
  LinkTo: Paths.HealthStore
};

export const thumbNailAccessHealthStoreHOL = {
  IconSrc: ThumbnailHealthStoreSrc,
  Heading: "View your customer offers", 
  Description:
    "Keep fit for less with our special gym offer or explore your health and lifestyle with a discounted health assessment.",
  LinkText: "Discover",
  LinkTo: Paths.HealthStore
};

export const thumbNailAskAMedicalExpert = {
  IconSrc: ThumbnailAskMedExpertSrc,
  Heading: "24/7 health support line",
  Description:
    "Speak to one of our nurses, counsellors, midwives or pharmacists about your health, either online or on the phone.",
  LinkText: "Discover",
  LinkTo: Paths.AskAMedicalExpert
};
